/**
 * "External MCP servers" — Dashboard section (ADR-0074).
 * Reconciled from apps/web byomcp feature (route /byomcp): register MCP servers
 * you host so Syncanix forwards tool calls to them, optionally acting as the
 * signed-in end user.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_BYOMCP_PAGE: DocPageContent = {
  slug: 'dashboard/byomcp',
  titleKey: 'docs.dashboard.byomcp.title',
  descriptionKey: 'docs.dashboard.byomcp.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.byomcp.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'register',
      textKey: 'docs.dashboard.byomcp.register.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.byomcp.register.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.byomcp.register.item.url',
        'docs.dashboard.byomcp.register.item.auth',
        'docs.dashboard.byomcp.register.item.allowlist',
        'docs.dashboard.byomcp.register.item.runas',
      ],
    },
    {
      kind: 'code',
      language: 'bash',
      code: 'syncanix byomcp register',
      captionKey: 'docs.dashboard.byomcp.register.cli',
    },

    { kind: 'heading', level: 2, id: 'manage', textKey: 'docs.dashboard.byomcp.manage.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.byomcp.manage.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.byomcp.manage.item.connection',
        'docs.dashboard.byomcp.manage.item.rotate',
        'docs.dashboard.byomcp.manage.item.tools',
        'docs.dashboard.byomcp.manage.item.status',
      ],
    },

    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.byomcp.security.title',
      textKey: 'docs.dashboard.byomcp.security.body',
      links: {
        confirm: {
          target: { docSlug: 'confirmation' },
          labelKey: 'docs.dashboard.byomcp.security.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.byomcp.next.mcp.title',
          textKey: 'docs.dashboard.byomcp.next.mcp.text',
          to: { docSlug: 'mcp' },
        },
        {
          titleKey: 'docs.dashboard.byomcp.next.actAsUser.title',
          textKey: 'docs.dashboard.byomcp.next.actAsUser.text',
          to: { docSlug: 'guides/act-as-user' },
        },
      ],
    },
  ],
};
